import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/consultations/psychiatry";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	psychiatry: {
		id: "ktx.psychiatry.title",
		defaultMessage: "Pszichiátria"
	},
	result: {
		id: "ktx.psychiatry.field.result",
		defaultMessage:
			"Konzílium eredménye alapján (Kérjük ismert alapbetegség, vagy nefrológus kezelőorvos javaslata alapján súlyos noncomplience esetén mindenképpen töltse ki az űrlapot)"
	},
	comment: {
		id: "ktx.psychiatry.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_psychiatry",
	value: {
		schemaId: "psychiatry",
		title: messages.psychiatry,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
